import { render } from "./Calendar.vue?vue&type=template&id=419b61ba"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Calendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "419b61ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('419b61ba', __exports__)) {
    api.reload('419b61ba', __exports__)
  }
  
  module.hot.accept("./Calendar.vue?vue&type=template&id=419b61ba", () => {
    api.rerender('419b61ba', render)
  })

}


export default __exports__